// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1_fTV","cls2":"WinBackPing-cls2_c3e WinBackPing-cls1_fTV"};